import { $isMarkNode } from '@lexical/mark';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getSelection, $isRangeSelection, $selectAll } from 'lexical';
import { useEffect } from 'react';
import { useEditModeContext } from './EditModeContextPlugin';

export const SelectAllAutoFocusPlugin: React.FunctionComponent = () => {
  const [editor] = useLexicalComposerContext();
  const editMode = useEditModeContext();

  useEffect(() => {
    if (!editMode) {
      return;
    }
    const isClickOnAbbreviationNode = editor.read(() => {
      const selection = $getSelection();

      return $isRangeSelection(selection) && $isMarkNode(selection.anchor.getNode().getParent());
    });

    if (isClickOnAbbreviationNode) {
      return;
    }

    editor.update($selectAll);
    editor.focus();
  }, [editMode, editor]);

  return null;
};
